export const SET_FORFAITS_TRANSPORT = 'SET_FORFAITS_TRANSPORT'
export const SET_FORFAIT_TRANSPORT = 'SET_FORFAIT_TRANSPORT'
export const ADD_FORFAIT_TRANSPORT = 'ADD_FORFAIT_TRANSPORT'
export const DELETE_FORFAIT_TRANSPORT = 'DELETE_FORFAIT_TRANSPORT'
export const UPDATE_FORFAIT_TRANSPORT = 'UPDATE_FORFAIT_TRANSPORT'
export const SET_TRANCHE_FORFAIT_TRANSPORT = 'SET_TRANCHE_FORFAIT_TRANSPORT'
export const ADD_TRANCHE_FORFAITS_TRANSPORT = 'ADD_TRANCHE_FORFAITS_TRANSPORT'
export const SET_PROPERTY_FORFAIT_TRANSPORT = 'SET_PROPERTY_FORFAIT_TRANSPORT'
export const SET_TYPE_FORFAIT_TRANSPORT = 'SET_TYPE_FORFAIT_TRANSPORT'
export const SET_AGENCE_FORFAIT_TRANSPORT = 'SET_AGENCE_FORFAIT_TRANSPORT'
